import { render, staticRenderFns } from "./NfeReceipt.vue?vue&type=template&id=0d756013&scoped=true"
import script from "./NfeReceipt.vue?vue&type=script&lang=js"
export * from "./NfeReceipt.vue?vue&type=script&lang=js"
import style0 from "./NfeReceipt.vue?vue&type=style&index=0&id=0d756013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d756013",
  null
  
)

export default component.exports